#import "../../../common/graphql/ExtractionTypes.graphql"
query UserSetupCommonData {
  secureRowLevels(orderBy: SECURITY_LEVEL_ASC
  filter:{ securityLevel: { lessThan: 100 } } ) {
    nodes {
      id
      description
      name
      securityLevel
    }
  }
  approvalTypes(orderBy: APPROVAL_TYPE_ASC) {
    nodes {
      id
      approvalType
    }
    totalCount
  }
  roles(orderBy: NAME_ASC) {
    nodes {
      id
      name
    }
  }
  companyDepartmentOccupationTemplates(
    orderBy: DEPARTMENT_OCCUPATION_TEMPLATE_BY_DEPARTMENT_OCCUPATION_TEMPLATE_ID__NAME_ASC
  ) {
    nodes {
      departmentOccupationTemplateId
      departmentOccupationTemplate {
        name
        description
        roleId
        departmentId
        departmentGroupId
        dataAccessPolicyId
        userOccupationTitleId
        userGroupId
        accessGroupId
        tagGroupId
        communicationGroupId
        isTemplateControlled
      }
    }
  }
  userInviteStatusTypes(
    orderBy: USER_PROFILES_BY_INVITATION_STATUS_TYPE_ID__COUNT_ASC
  ) {
    nodes {
      id
      statusType
      isSelectable
      isDefault
    }
  }
  companyTagGroups(orderBy: TAG_GROUP_BY_TAG_GROUP_ID__NAME_ASC) {
    nodes {
      tagGroupId
      tagGroup {
        name
      }
    }
  }
  companyCommunicationGroups(
    orderBy: COMMUNICATION_GROUP_BY_COMMUNICATION_GROUP_ID__NAME_ASC
  ) {
    nodes {
      communicationGroupId
      communicationGroup {
        name
      }
    }
  }
  userStatusTypes(orderBy: STATUS_TYPE_ASC) {
    nodes {
      id
      statusType
    }
  }
  companyAccessGroups(orderBy: ACCESS_GROUP_BY_ACCESS_GROUP_ID__NAME_ASC) {
    nodes {
      accessGroupId
      accessGroup {
        name
      }
    }
  }
  companyUserOccupationTitles(
    orderBy: USER_OCCUPATION_TITLE_BY_USER_OCCUPATION_TITLE_ID__USER_OCCUPATION_TITLE_ASC
  ) {
    nodes {
      userOccupationTitleId
      userOccupationTitles {
        userOccupationTitle
      }
    }
  }
  companyUserGroups(orderBy: USER_GROUP_BY_USER_GROUP_ID__NAME_ASC) {
    nodes {
      userGroupId
      userGroup {
        name
      }
    }
  }
  companyDepartments(orderBy: NAME_ASC) {
    nodes {
      id
      name
    }
  }
  companyDepartmentGroups(
    orderBy: DEPARTMENT_GROUP_BY_DEPARTMENT_GROUP_ID__NAME_ASC
  ) {
    nodes {
      departmentGroupId
      departmentGroup {
        name
      }
    }
  }
  userProfileAvailableDocumentTypes {
    nodes {
      id
      documentType
      isAccountingDocument
      ...ExtractionTypes
    }
  }
  companyDataAccessPolicies(
    orderBy: DATA_ACCESS_POLICY_BY_DATA_ACCESS_POLICY_ID__NAME_ASC
  ) {
    nodes {
      dataAccessPolicyId
      dataAccessPolicy {
        name
      }
    }
  }
}
